import ChileAdapter from './es-cl/adapter.cl'
import MexicoAdapter from './es-mx/adapter.mx'
import ColombiaAdapter from './es-co/adapter.co'
import PeruAdapter from './es-pe/adapter.pe'
import EcuadorAdapter from './es-ec/adapter.ec'
import DefaultAdapter from './default/adapter.default'

const strategy = {
  es_CO: ColombiaAdapter,
  es_CL: ChileAdapter,
  es_PE: PeruAdapter,
  es_EC: EcuadorAdapter,
  es_MX: MexicoAdapter,
  __default__: DefaultAdapter
}

export const getOnlineSaleCommissionMessage = langKey => {
  return strategy[langKey]
    ? strategy[langKey].commission
    : strategy.__default__.commission
}

export const getDisclaimerOnlineSaleMessage = (langKey, isB2C) => {
  return strategy[langKey]
    ? strategy[langKey].disclaimerOnline(isB2C)
    : strategy.__default__.disclaimer
}

export const getDisclaimerMessage = (langKey, isF2F) => {
  return strategy[langKey]
    ? strategy[langKey].disclaimer(isF2F)
    : strategy.__default__.disclaimer
}
